import { Skeleton,Stack } from "@mui/material";
import { useContext,useEffect,useState } from "react";
import { useTranslation } from "react-i18next";
import { BsShieldFillCheck } from "react-icons/bs";
import { Link,useLocation } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { trackEventMatomo } from "../../helpers/matomo";
import UserCard from "../UserCard/UserCard";
import Links from "./Links";
import * as Style from "./SideBarStyle";

export default function Sidebar() {
  const { userData, isHidden, setIsHidden, funcionalitiesList, loadingFuncionalities, setLoadingFuncionalities } = useContext(UserContext);
  const [empresaProfiles, setEmpresaProfiles] = useState<string[]>([]);
  const [profile, setProfile] = useState<string>('');
  const { t } = useTranslation("translation");

  const location = useLocation();

  useEffect(() => {
    if (userData && loadingFuncionalities) {
      setEmpresaProfiles(userData.listaFuncionalidades);
      setProfile(userData.role);
    }
    if (profile && empresaProfiles && loadingFuncionalities) {
      setLoadingFuncionalities(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresaProfiles, profile, loadingFuncionalities, userData]);

  useEffect(() => {
    if (window.innerWidth <= 750) {
      setIsHidden(!isHidden);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !loadingFuncionalities ? (
    <Style.Container hidden={isHidden}>
      <UserCard />
      <ul style={{ width: "inherit" }}>
        {funcionalitiesList
          ?.sort((a, b) => (a.id > b.id ? 1 : -1))
          ?.filter((ele) => userData.listaFuncionalidades.includes(ele.key))
          ?.map((e) => ({
            ...e,
            key: e.key === "powerbi" ? "estatisticas" : e.key,
          }))
          ?.filter((e, index, self) => index === self.findIndex((item) => item.key === e.key))
          ?.map((e, i) => (
            <li
              key={i}
              onClick={() => trackEventMatomo('navegação global', 'click', 'menu lateral', e.key)}
            >
              <Links option={e.key} />
            </li>
          ))}
        {userData.aprovador && (
          <li>
            <Link
              to={`/aprovacao`}
              onClick={() => trackEventMatomo('navegação global', 'click', 'menu lateral', 'aprovação')}
            >
              <Style.StyledLinkDiv theme={location.pathname === "/aprovacao" ? "selected" : ""}>
                <BsShieldFillCheck className={isHidden ? "hidden-icon" : "icon"} />
                {!isHidden && <h1>{t("csv.aprovation")}</h1>}
              </Style.StyledLinkDiv>
            </Link>
          </li>
        )}
      </ul>
    </Style.Container>
  ) : (
    <Style.Container hidden={isHidden}>
      <UserCard />
      <Stack direction="column" width="100%" justifyContent="flex-start" alignItems="flex-start" spacing={2} padding={1}>
        {Array.from({ length: 10 }).map((_ele, ind) => {
          return <Skeleton key={ind} variant="rounded" width={200} height={30} />;
        })}
      </Stack>
    </Style.Container>
  );
}
